export type OrderType = {
  value: string;
  label: string;
};

export const OrderTypes: OrderType[] = [
  { value: "FLOWER", label: "Blommor" },
  { value: "CANDLE", label: "Minnesljus" },
];
